// Module
var code = "<div class=\"grid-cell-wrapper marker\"> <span data-bind=\"css: { 'currencyIconPadding': $data.FormatName === 'Currency' && !!$data.Value }\" class=\"valueBox\"> <!--ko text: $data.Value --><!-- /ko --> <!--ko if: $data.FormatName === 'Currency' && !!$data.Value --> <i class=\"currencyIcon\"></i> <!-- /ko --> </span> </div>";
// Exports
export default code;